import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VCalendar from 'v-calendar'
import print from 'vue3-print-nb'
import vue3GoogleLogin from 'vue3-google-login'
import i18n from './i18n'
import { vfmPlugin } from 'vue-final-modal'

import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import '@/assets/scientific-design-system.css'




createApp(App).use(i18n).use(vue3GoogleLogin, { clientId: '959641013461-aa2o8a3bcun35kmiqjfqnlkcfhqujduq.apps.googleusercontent.com' }).use(VCalendar, {}).use(router).use(VueAxios, axios).use(print).use(vfmPlugin).mount('#app')
